import React, { useContext, useEffect, useState } from 'react'
import styles from './LbDashboardOverview.module.css'
import { FaGlobe, FaWpforms, FaUsers, FaChartLine } from 'react-icons/fa'
import { motion } from 'framer-motion'
import { BASE_URL_API } from '../../../References/URLs'
import AuthContext from '../../../store/auth-context'
import ActiveStoreContext from '../../../store/ActiveStoreContext'
import { Link } from 'react-router'



const LbDashboardOverview = () => {
    const authCtx = useContext(AuthContext)
    const asCtx = useContext(ActiveStoreContext);
    const vendorIdentifier = JSON.parse(authCtx?.loginData)?.partnersData?.vendorIdentifier
    const activeStore = (() => { try { return (asCtx?.activeStore && asCtx.activeStore.trim() !== "") ? JSON.parse(asCtx.activeStore) : null; } catch { return null; } })();

    const [metrics, setMetrics] = useState([
        {
            title: 'Total Domains',
            value: 0,
            icon: <FaGlobe />,
            color: '#3f5efb'
        },
        {
            title: 'Total Forms',
            value: 0,
            icon: <FaWpforms />,
            color: '#00c9a7'
        },
        {
            title: 'Leads Captured',
            value: 0,
            icon: <FaUsers />,
            color: '#ff8c00'
        },
        {
            title: 'Conversion Rate',
            value: 'NA',
            icon: <FaChartLine />,
            color: '#e63946'
        }
    ])

    const [topPerformingForms, setTopPerformingForms] = useState([])

    const getDashboardData = async () => {
        const response = await fetch(BASE_URL_API + "lb_getDashboardOverviewStats",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    vendorIdentifier: vendorIdentifier,
                    storeIdentifier: activeStore.storeIdentifier
                })
            });

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo?.status === "success") {
                setMetrics([
                    {
                        title: 'Total Domains',
                        value: respo?.response?.totalDomains,
                        icon: <FaGlobe />,
                        color: '#3f5efb'
                    },
                    {
                        title: 'Total Forms',
                        value: respo?.response?.totalForms !== null ? respo?.response?.totalForms : 0,
                        icon: <FaWpforms />,
                        color: '#00c9a7'
                    },
                    {
                        title: 'Leads Captured',
                        value: respo?.response?.totalLeads !== null ? respo?.response?.totalLeads : 0,
                        icon: <FaUsers />,
                        color: '#ff8c00'
                    },
                    {
                        title: 'Conversion Rate',
                        value: 'NA',
                        icon: <FaChartLine />,
                        color: '#e63946'
                    }
                ])

                setTopPerformingForms(respo?.response?.topPerformingForms)
            } else {
                if (respo?.message === "tokenExpired") {
                    authCtx.logout()
                }
            }
            console.log(respo)
        }
    }

    console.log(topPerformingForms)

    useEffect(() => {
        getDashboardData()
    }, [activeStore?.storeIdentifier])

    if (activeStore === null) {
        return (
            <div>
                Please select a store.
            </div>
        )
    }



    return (
        <div className={styles.overview}>
            <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
            >
                <h2 className={styles.heading}>Dashboard Overview</h2>
            </motion.div>

            <div className={styles.metricsGrid}>
                {metrics.map((m, i) => (
                    <motion.div
                        key={i}
                        className={styles.metricCard}
                        style={{ borderLeft: `5px solid ${m.color}` }}
                        initial={{ opacity: 0, y: 40 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 + i * 0.1 }}
                    >
                        <div className={styles.iconWrapper} style={{ background: m.color }}>
                            {m.icon}
                        </div>
                        <div>
                            <p className={styles.metricTitle}>{m.title}</p>
                            <h3 className={styles.metricValue}>{m.value}</h3>
                        </div>
                    </motion.div>
                ))}
            </div>

            <div className={styles.section}>
                <div className={styles.headingSec}>Lead Trends</div>
                <div className={styles.placeholder}>
                    📈 Lead trends chart will appear here.
                </div>
            </div>

            <div className={styles.section}>
                <div className={styles.headingSec}>Top Performing Forms</div>
                <div className={styles.formList}>
                    {topPerformingForms?.length > 0 ? (
                        topPerformingForms.map((item, index) => (
                            <Link
                                key={index}
                                to={`/leadbridge/forms/${item?.formIdentifier}`}
                                className={styles.formCard}
                            >
                                <div className={styles.formName}>{item?.formName}</div>
                                <div className={styles.formStats}>
                                    {item?.totalSubmissions} lead{item?.totalSubmissions > 1 ? 's' : ''}
                                </div>
                            </Link>
                        ))
                    ) : (
                        <p className={styles.noForms}>No forms found.</p>
                    )}
                </div>
            </div>

        </div>
    )
}

export default LbDashboardOverview
